import { useAuthModal } from 'src/hooks/use-auth-modal'
import { getMainLayout } from 'src/layout/main-layout'
import { NextPageWithLayout } from 'src/pages/_app'
import { MapExplorer } from 'src/views/map-explorer/content'

const MainPage: NextPageWithLayout = () => {
  useAuthModal()
  return <MapExplorer />
}

MainPage.getLayout = getMainLayout

export default MainPage
